import * as React from 'react';
import * as styles from './styles.css';
import { Trend } from '../Trend';

import { ETrend } from '../../types/share';

import { Header1, InlineText1 } from '@cian/ui-kit/typography';

export interface IDynamicInfoProps {
  trend: ETrend;
  title: string;
  description?: string;
}

export function DynamicInfo({ trend, title, description }: IDynamicInfoProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['top-content']}>
        <div className={styles['trend']}>
          <Trend trend={trend} />
        </div>
        <Header1>{title}</Header1>
      </div>
      {description && (
        <div className={styles['description']}>
          <InlineText1 color="black_60">{description}</InlineText1>
        </div>
      )}
    </div>
  );
}
